module.exports = __webpack_public_path__ + "img/teotihuacan.cfd1dd04.jpg";